import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import { initialFreefieldProfileFilter } from "./FilterTypes/FreefieldProfileFilterType";
import MultiFreeFieldProfileList from "components/Picker/FreefieldProfile/MultiFreeFieldProfileList";

interface Props {
  environment: server.dto.Environments
}

const FreefieldProfileFilter = (props: Props) => {
  const title = RESX.FreeField.FreeFieldPermissionProfile;
  const applyRef = React.useRef<any>(null);

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("freefieldProfile", {
    getTitle: () => title,
    renderSelection: (filter) => <>{filter.freefieldProfiles.map(p => p.title).join(", ")}</>,
    hasValue: (filter) => filter.freefieldProfiles.length > 0,
    reset: () => initialFreefieldProfileFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.freefieldProfiles.map(a => a.freeFieldProfileId), b.freefieldProfiles.map(a => a.freeFieldProfileId))
  });
  useEffect(() => {
    setInitialValue("freefieldProfile", initialFreefieldProfileFilter);
  }, []);

  const [selectedFreefieldProfiles, setSelectedFreefieldProfiles] = React.useState<server.dto.FreeFieldProfileSmall[]>(initialFreefieldProfileFilter.freefieldProfiles);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedFreefieldProfiles(getValue("freefieldProfile").freefieldProfiles);
    setPopupOpen(true);
  };

  const onFreefieldsSelected = (ffs: server.dto.FreeFieldProfileSmall[]) => {
    setSelectedFreefieldProfiles(ffs);
    applyRef?.current?.focus();
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("freefieldProfile", {
      freefieldProfiles: selectedFreefieldProfiles
    });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiFreeFieldProfileList
        value={selectedFreefieldProfiles}
        onChange={onFreefieldsSelected}
        environment={props.environment}
      />
    </MultiPickerFilterPopup>
  </div>
};


export default FreefieldProfileFilter;
